import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { PartnerMobileAppType } from '@/common/constants';
import { API_URL } from '@/dtos';

import { PartnerAppLinks } from '../continueInAppPopup.types';

interface PartnerAppLinksPayload {
  partner_mobile_app?: PartnerMobileAppType;
  partner_app_ios_link?: string;
  partner_app_android_link?: string;
  logo_info?: {
    large_logo_url?: string;
    minimized_logo_url?: string;
    favicon_url?: string;
  };
}

interface Props {
  hashId?: string;
}

export const useGetAppLinksQuery = ({ hashId }: Props) => {
  const { data, isLoading, isError } = useQuery(
    [API_URL.ORGANIZATION_PROPERTIES_HASH_BY_HASH_ID(hashId || '')],
    () => api.get(API_URL.ORGANIZATION_PROPERTIES_HASH_BY_HASH_ID(hashId || '')),
    {
      enabled: !!hashId,
      retry: false,
    }
  );

  const formattedData = useMemo(
    (): PartnerAppLinks => ({
      partnerAppAndroidLink: data?.data?.partner_app_android_link,
      partnerAppIosLink: data?.data?.partner_app_ios_link,
      partnerMobileApp: data?.data?.partner_mobile_app as unknown as PartnerMobileAppType,
      logoInfo: {
        largeLogoUrl: data?.data?.logo_info?.favicon_url,
        minimizedLogoUrl: data?.data?.logo_info?.minimized_logo_url,
        faviconUrl: data?.data?.logo_info?.favicon_url,
      },
    }),
    [data]
  );

  return {
    appLinks: formattedData,
    isLoading,
    isError,
  };
};
